import { connected } from '@ambiki/impulse';

/**
 * Initializes the bootstrap popover component when element is connected to the DOM and disposes it when element is
 * removed from the DOM.
 */
connected('[data-toggle="popover"]', (element) => {
  if ($.isFunction($('[data-toggle="popover"]').popover)) {
    $(element).popover();
  }

  return () => {
    if ($.isFunction($('[data-toggle="popover"]').popover)) {
      $(element).popover('dispose');
    }
  };
});
